export default __webpack_public_path__ + "static/media/05.cdcbafd8.jpg";